export const WEIGHT_RANGE_CONFIG = {
    step: 1,
    range: {
        min: 0,
        max: 10
    },
    pips: {
        mode: 'steps',
        density: 10
    }
};